import React from 'react';
import { IEvent } from '../../utils/models';
import SEO from '../SEO';

interface IStrapiPageSEOProps {
  item: IEvent;
}
const StrapiPageSEO = ({ item }: IStrapiPageSEOProps) => {
  const { title, shortDescription, description } = item;
  const { metaTitle = '', metaDescription = '' } = item.SEO || {};
  const seoTitle = metaTitle || title;
  const seoDescription =
    metaDescription ||
    shortDescription ||
    description?.replace(/<\/?\w*\b[^>]*>/gi, '') || // remove HTML tags
    '';

  return <SEO title={seoTitle} description={seoDescription} />;
};

export default StrapiPageSEO;
